'use client';

import type { FC } from 'react';
import NavIconActions from '@/components/navigation/NavIconActions/NavIconActions.client';
import NavSidebarContent from '@/components/navigation/NavSidebarContent/NavSidebarContent.client';
import ArrowLink from '@/components/ui/ArrowLink';

type TSidebarContent = {
  onClose: (value: boolean) => void;
};

const SidebarContent: FC<TSidebarContent> = ({ onClose }) => {
  return (
    <div className='flex h-full flex-col bg-transparent'>
      <div className='flex-1 overflow-y-auto bg-transparent px-6 pb-32'>
        <NavSidebarContent onClose={onClose} />
      </div>
      <div className='px-6'>
        <div className='flex justify-end pb-3'>
          <NavIconActions />
        </div>
        <div className='py-2 border-t border-gray-500/10 dark:border-white/10'>
          <ArrowLink
            href='https://app.bunkersuite.com'
            target='_blank'
            size='md'
            className='mt-3 flex w-full items-center justify-center rounded-md bg-info px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-info/90'
          >
            Log in
          </ArrowLink>
        </div>
      </div>
    </div>
  );
};

export default SidebarContent;
